"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isProductOwnedAdapter = _interopRequireDefault(require("self-service-api/adapters/isProductOwnedAdapter"));

var _ProductTierOrders = _interopRequireDefault(require("self-service-api/constants/ProductTierOrders"));

var _helpers = require("self-service-api/core/utilities/helpers");

var _SynonymousProducts = _interopRequireDefault(require("self-service-api/constants/SynonymousProducts"));

var hasHigherTieredProductAdapter = function hasHigherTieredProductAdapter(productData, parcels, merchandiseId) {
  var merchandiseIdsTreatedAsOwned = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var tieredProductsGroup = _ProductTierOrders.default.filter(function (productTierOrder) {
    return productTierOrder.indexOf(merchandiseId) !== -1;
  })[0];

  if (!tieredProductsGroup) {
    return false;
  }

  var tierIndex = tieredProductsGroup.indexOf(merchandiseId);
  var highestMerchIdOwned = (0, _helpers.findIndex)(tieredProductsGroup, function (tieredMerchandiseId) {
    return merchandiseIdsTreatedAsOwned.includes(tieredMerchandiseId);
  });
  var hasHigherMerchandiseIdsTreatedAsOwned = tierIndex < highestMerchIdOwned;
  if (hasHigherMerchandiseIdsTreatedAsOwned) return true;
  var higherTieredProductGroups = tieredProductsGroup.slice(tierIndex + 1, tieredProductsGroup.length); // Check against parcel logic for HubSpot internal PROD portals since merchandiseIdsTreatedAsOwned
  // always returns an empty array.
  // More context: https://hubspot.slack.com/archives/C9N90FN4B/p1579627126012200

  var hasHigherParcel = higherTieredProductGroups.some(function (tieredMerchandiseId) {
    var isSynonymousProduct = _SynonymousProducts.default.some(function (synonymousProducts) {
      return synonymousProducts.includes(merchandiseId) && synonymousProducts.includes(tieredMerchandiseId);
    });

    return !isSynonymousProduct && (0, _isProductOwnedAdapter.default)(productData, parcels, tieredMerchandiseId);
  });
  return hasHigherParcel;
};

var _default = hasHigherTieredProductAdapter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/adapters/hasHigherTieredProductAdapter.js
// module id = 423
// module chunks = 5 6 7